import { createSlice } from "@reduxjs/toolkit";

const layoutSlice = createSlice({
  name: "layout",
  initialState: {
    rightPanelOpen: false,
    rightPanelExpanded: true,
    rightPanelContent: null,
    composerHeight: 0,
  },
  reducers: {
    openRightPanel: (state, action) => {
      state.rightPanelContent = action?.payload?.content;
      state.rightPanelOpen = true;
    },
    closeRightPanel: (state) => {
      state.rightPanelContent = null;
      state.rightPanelOpen = false;
    },
    expandRightPanel: (state) => {
      state.rightPanelExpanded = true;
    },
    collapseRightPanel: (state) => {
      state.rightPanelExpanded = false;
    },
    setComposerHeight: (state, action) => {
      state.composerHeight = action?.payload?.composerHeight;
    },
  },
});

export const {
  openRightPanel,
  closeRightPanel,
  expandRightPanel,
  collapseRightPanel,
  setComposerHeight,
} = layoutSlice.actions;

export default layoutSlice.reducer;

export const selectIsRightPanelOpen = (state) => {
  return state.layout.rightPanelOpen;
};

export const selectIsRightPanelExpanded = (state) => {
  return state.layout.rightPanelExpanded;
};

export const selectRightPanelContent = (state) => {
  return state.layout.rightPanelContent;
};

export const selectComposerHeight = (state) => {
  return state.layout.composerHeight;
};
